import React from 'react'
import NavBar from '../Component/NavBarFooter/NavBar'
// import Banner from '../Component/Home/Banner'
import Listing from '../Component/RentelSpaces/Listing'
import Footer from '../Component/NavBarFooter/Footer'
import { Helmet } from 'react-helmet'

function RentelSpaces() {
  return (
    <div>
        <Helmet>
        <title>Photography Studio Spaces for Rent – Pakistan</title>
        <meta name="description" content="Rent professional studio spaces for photoshoots, videos, and content creation in Pakistan. Perfect for models, brands, and creators. Book your slot now." />
      </Helmet>
        <NavBar/>
        {/* <Banner/> */}
        <Listing/>
        <Footer/>
        
    </div>
  )
}

export default RentelSpaces